import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface AppState {
  isLoading: boolean;
  error: string | null;
  sidebarOpen: boolean;
  theme: 'light' | 'dark';
}

const initialState: AppState = {
  isLoading: false,
  error: null,
  sidebarOpen: false,
  theme: 'light',
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    toggleSidebar: state => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload;
    },
    clearError: state => {
      state.error = null;
    },
  },
});

export const { setLoading, setError, toggleSidebar, setTheme, clearError } =
  appSlice.actions;
export default appSlice.reducer;
